<template>
  <DialogLayout
    title="補正登録"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForWeightAndNoiseForm
        ref="feesForWeightAndNoiseForm"
        v-model="feesForWeightAndNoiseFormModel"
        label-width="10em"
        formMode="register"
        billingYmMode="this"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
      />
    </template>
    <template #footer>
      <RegisterDialogFooter
        @clear="clickClear"
        @register="clickRegister"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForWeightAndNoiseForm from '@/components/organisms/dialog/calculation/FeesForWeightAndNoiseForm.vue'
import RegisterDialogFooter from '@/components/organisms/dialog/RegisterDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForWeightAndNoiseForm,
    RegisterDialogFooter
  },
  props: {
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForWeightAndNoiseFormModel: {
        registration_symbol: undefined,
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: undefined,
        route_code: undefined,
        callsign: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        model_code: undefined,
        landing_fee_without_tax: undefined,
        landing_fee_tax: undefined,
        landing_fee_with_tax: undefined,
        count: undefined,
        landingFeeBeforeExemption: undefined,
        landing_time: undefined,
        tax: undefined,
        flight_purpose_code: undefined,
        aircraft_type: undefined,
        weight: undefined,
        noise_level: undefined,
        exemption_code: undefined,
        exemption_rate: undefined,
        unit_fee: undefined,
        taxation: undefined,
        regist_type: undefined,
        billing_exclusion_flag: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.feesForWeightAndNoiseForm.clearFields()
    },
    async clickRegister () {
      this.$loadingMask.on()
      this.$refs.feesForWeightAndNoiseForm.validate()
        .then((valid) => {
          return this.$axios.post('/fees-for-weight-and-noise', this.feesForWeightAndNoiseFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForWeightAndNoiseFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['registration_symbol', 'bill_to_code', 'route_code']
      this.$nextTick(() => {
        this.$refs.feesForWeightAndNoiseForm.clearFields()
        Object.keys(this.feesForWeightAndNoiseFormModel)
          .forEach((x) => {
            if (trimItem.includes(x) && this.currentRow[x]) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            if (this.currentRow[x] !== undefined) {
              this.$set(this.feesForWeightAndNoiseFormModel, x, this.currentRow[x])
            }
          })
        if (!this.feesForWeightAndNoiseFormModel.billing_exclusion_flag) {
          this.feesForWeightAndNoiseFormModel.billing_exclusion_flag = undefined
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>
